import { render, staticRenderFns } from "./HowToBy.vue?vue&type=template&id=06eff8ca&"
import script from "./HowToBy.vue?vue&type=script&lang=js&"
export * from "./HowToBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports